/* AVELY GLOW - selecteur de variantes (section AG - Produit)
   Met a jour la variante reelle, le prix et la disponibilite.
   Aucun prix code en dur : tout vient des donnees Shopify. */
(function () {
  'use strict';

  if (window.__avelyProductInit) return;
  window.__avelyProductInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function cssEscape(value) {
    var str = String(value);
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(str);
    return str.replace(/[^a-zA-Z0-9_-]/g, function (ch) {
      return '\\' + ch;
    });
  }

  function initSection(root) {
    var dataEl = root.querySelector('[data-ag-product-variants]');
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!dataEl || !form) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = form.querySelector('[data-ag-variant-id]');
    var priceEl = root.querySelector('[data-ag-price]');
    var colorLabel = root.querySelector('[data-ag-color-label]');
    var atc = form.querySelector('[data-ag-atc]');

    function selected(name) {
      var el = form.querySelector('[data-ag-option="' + name + '"]:checked');
      return el ? el.value : null;
    }

    function find(color, size) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if ((color === null || v.o1 === color) && (size === null || v.o2 === size)) return v;
      }
      return null;
    }

    function firstAvailableForColor(color) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if ((color === null || v.o1 === color) && v.available !== false) return v;
      }
      return null;
    }

    function update() {
      var color = selected('color');
      var size = selected('size');

      // Disponibilite des tailles pour le coloris choisi
      var wrappers = root.querySelectorAll('[data-ag-size-wrapper]');
      Array.prototype.forEach.call(wrappers, function (w) {
        var sizeName = w.getAttribute('data-ag-size-wrapper');
        var v = find(color, sizeName);
        if (v && v.available === false) w.classList.add('ag-size--unavailable');
        else w.classList.remove('ag-size--unavailable');
      });

      if (colorLabel && color) colorLabel.textContent = color;

      var variant = find(color, size);

      // Si la taille cochee n'existe pas ou n'est plus disponible pour ce
      // coloris, on bascule sur la premiere taille disponible du coloris.
      if (!variant || variant.available === false) {
        var fallback = firstAvailableForColor(color);
        if (fallback) {
          var radio = form.querySelector(
            '[data-ag-option="size"][value="' + cssEscape(fallback.o2) + '"]'
          );
          if (radio) radio.checked = true;
          variant = fallback;
        }
      }

      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        var html = variant.price;
        if (variant.has_compare) {
          html += ' <span class="ag-price__compare">' + variant.compare + '</span>';
        }
        priceEl.innerHTML = html;
      }

      if (atc) {
        if (variant.available === false) {
          atc.disabled = true;
          atc.dataset.agOriginal = atc.dataset.agOriginal || atc.textContent.trim();
          atc.textContent = 'Indisponible';
        } else {
          atc.disabled = false;
          if (atc.dataset.agOriginal) atc.textContent = atc.dataset.agOriginal;
        }
      }

      // Reflete la variante dans l'URL sur la page produit uniquement
      if (window.location.pathname.indexOf('/products/') === 0 && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.matches('[data-ag-option]')) update();
    });

    update();

    // Guide des tailles
    var dialog = root.querySelector('[data-ag-sizeguide]');
    if (dialog) {
      var openBtn = root.querySelector('[data-ag-sizeguide-open]');
      var closeBtn = root.querySelector('[data-ag-sizeguide-close]');
      if (openBtn) {
        openBtn.addEventListener('click', function () {
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        });
      }
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          if (typeof dialog.close === 'function') dialog.close();
          else dialog.removeAttribute('open');
        });
      }
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog && typeof dialog.close === 'function') dialog.close();
      });
    }
  }

  ready(function () {
    var sections = document.querySelectorAll('[id^="ag-product-"]');
    Array.prototype.forEach.call(sections, initSection);
  });
})();
